import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import { Button, Stack, Typography } from "@mui/material";

import React from "react";
import { useTranslation } from "react-i18next";

export type DropzoneEmptyStateProps = {
  isDragActive: boolean;
  disabled: boolean;
  acceptedFormats?: string;
  onFileUpload: (files: File[]) => Promise<void>;
  setCallFn: (value: boolean) => void;
};

export const DropzoneEmptyState: React.FC<DropzoneEmptyStateProps> = ({
  isDragActive,
  disabled,
  acceptedFormats,
  onFileUpload,
  setCallFn,
}) => {
  const { t } = useTranslation();

  const acceptedFormatsList = acceptedFormats
    ?.split(",")
    .map((e) => e.trim())
    .join(", ");

  return (
    <Stack direction="column" alignItems="center" justifyContent="center">
      <Stack direction="row" alignItems="center" justifyContent="center" gap={1}>
        <FileUploadOutlinedIcon color={isDragActive ? "primary" : undefined} />

        {!isDragActive && (
          <Typography variant="body2">
            {t("upload.dragFileHereOr")}
            <Button variant="text" component="label" color="primary" disabled={disabled} style={{ marginTop: "-1px" }}>
              {t("upload.selectFromComputer")}
              <input
                type="file"
                id="file"
                style={{ display: "none" }}
                disabled={disabled}
                accept={acceptedFormats}
                onChange={async (event) => {
                  if (disabled) return;
                  const files = event.target.files;
                  if (files && files.length > 0) {
                    setCallFn(true);
                    await onFileUpload(Array.from(files));
                    setCallFn(false);
                  }
                }}
              />
            </Button>
          </Typography>
        )}

        {isDragActive && (
          <Typography variant="body2" color="primary">
            {t("upload.dropHere")}
          </Typography>
        )}
      </Stack>
      {acceptedFormats && (
        <Typography variant="caption" color="text.secondary">
          {t("upload.acceptedFormats", {
            formats: acceptedFormatsList,
          })}
        </Typography>
      )}
    </Stack>
  );
};
